/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Umer Arif",
  title: "Hi all, I'm Umer",
  subTitle: emoji(
    "A passionate Front End Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs  / React Native and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/15dHi3raF5cEBV00rSDyjTtNhREkqMNvD/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/umerarif01",
  linkedin: "https://www.linkedin.com/in/umer-arif-a1439020b/",
  gmail: "umerarif01@gmail.com",
  facebook: "https://www.facebook.com/muhammadumer.arif.5",
  instagram:"https://www.instagram.com/umerarif01/",
  twitter:"https://twitter.com/umerarif01",
  stackoverflow: "https://stackoverflow.com/users/16453686/umer-arif",
  // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "FRONT END DEVELOPER WHO WANTS TO HELP PEOPLE BUILD THEIR APPS",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji(
      "⚡ Integration of third party services such as Firebase"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "React Native",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    
    
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Bahria University",
      logo: require("./assets/images/bh.png"),
      subHeader: "Bachelor in Computer Science",
      duration: "March 2021 - March 2025",
    },
    {
      schoolName: "The City School",
      logo: require("./assets/images/cs.jpg"),
      subHeader: "O and A level",
      duration: "August 2017 - August 2020",
    },
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "65%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Front-End Developer",
      company: "Fiver",
      companylogo: require("./assets/images/fiverr-2018.png"),
      date: "June 2019 – Present",
    
    },
    {
      role: "Front-End Developer",
      company: "Upwork",
      companylogo: require("./assets/images/up.png"),
      date: "May 2020 – Present",
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "SOME OF MY PERSONAL PROJECTS",
  projects: [
    {
      image: require("./assets/images/airbnb2.png"),
      projectName: "Airbnb-Clone",
      projectDesc: "Created clone of Airbnb with Next.js, Tailwind CSS, Date-picker and Map-Box",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://airbnb-clone-umera.vercel.app/"
        },
        {
          name: "Visit Github Repo",
          url: "https://github.com/umerarif01/Airbnb-Clone"
        }
      ]
    },
    {
      image: require("./assets/images/uber2.jpg"),
      projectName: "UBER-Clone",
      projectDesc: "Created Uber Clone with React Native and Google API.",
      footerLink: [
        {
          name: "Visit APP",
          url: "https://expo.dev/@umer-a/uber-clone"
        },
        {
          name: "Visit Github Repo",
          url: "https://github.com/umerarif01/Uber-Clone"
        }
      ]
    },
    {
      image: require("./assets/images/dw3.png"),
      projectName: "DarkWeb",
      projectDesc: "Created my own search engine with Next.js and Google Search Engine API.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://darkweba.netlify.app/"
        },
        {
          name: "Visit Github Repo",
          url: "https://github.com/umerarif01/DarkWeb"
        }
      ]
    },
    {
      image: require("./assets/images/Netflix.jpg"),
      projectName: "Netflix-Clone",
      projectDesc: "Created Netlix Clone with ReactJS,Redux,Firebase and TMDB API.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://netflix-clone-umera.netlify.app/"
        },
        {
          name: "Visit Github Repo",
          url: "https://github.com/umerarif01/Netflix-Clone"
        }
      ]
    },
    {
      image: require("./assets/images/tesla.jpg"),
      projectName: "Tesla-Homepage",
      projectDesc: "Created Tesla Homepage with React Native",
      footerLink: [
        {
          name: "Visit APP",
          url: "https://expo.dev/@umer-a/Tesla-Clone"
        },
        {
          name: "Visit Github Repo",
          url: "https://github.com/umerarif01/Tesla-Clone"
        }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3334218992",
  email_address: "umerarif01@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "umerarif01", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
